import { Notes, Head, Appear, Image } from "mdx-deck";
import gitHubDependabot from "../../../../../../images/github-dependabot.png";
import gitHubSecurityAlerts from "../../../../../../images/github-security-alerts.png";
import openPRs from "../../../../../../images/open-prs.png";
import openPRs2 from "../../../../../../images/open-prs2.png";
import prDetail from "../../../../../../images/pr-detail.png";
import prDetail2 from "../../../../../../images/pr-detail2.png";
import lmcLogo from "../../../../../../images/lmc-logo.png";
import audit from "../../../../../../images/audit.gif";
import auditResult from "../../../../../../images/audit-result.png";
import slackNoise1 from "../../../../../../images/slack-noise-1.png";
import slackNoise2 from "../../../../../../images/slack-noise-2.png";
import slackNoise3 from "../../../../../../images/slack-noise-3.png";
import pipeline from "../../../../../../images/pipeline.png";
import dependabot from "../../../../../../images/dependabot.png";
import greenkeeper from "../../../../../../images/greenkeeper.png";
import snyk from "../../../../../../images/snyk.webp";
import renovate from "../../../../../../images/renovate.jpg";
import frontendisti from "../../../../../../images/frontendisti.jpg";
import mask from "../../../../../../images/mask.png";
import { default as customTheme } from "../../../../../../src/theme";
import CenterLayout from "../../../../../../src/components/center-layout";
import Resource from "../../../../../../src/components/resource";
import Link from "../../../../../../src/components/link";
import { FullScreenCode } from 'mdx-deck';
import QuoteLayout from "../../../../../../src/components/qoute-layout";
import * as React from 'react';
export default {
  Notes: Notes,
  Head: Head,
  Appear: Appear,
  Image: Image,
  gitHubDependabot: gitHubDependabot,
  gitHubSecurityAlerts: gitHubSecurityAlerts,
  openPRs: openPRs,
  openPRs2: openPRs2,
  prDetail: prDetail,
  prDetail2: prDetail2,
  lmcLogo: lmcLogo,
  audit: audit,
  auditResult: auditResult,
  slackNoise1: slackNoise1,
  slackNoise2: slackNoise2,
  slackNoise3: slackNoise3,
  pipeline: pipeline,
  dependabot: dependabot,
  greenkeeper: greenkeeper,
  snyk: snyk,
  renovate: renovate,
  frontendisti: frontendisti,
  mask: mask,
  customTheme: customTheme,
  CenterLayout: CenterLayout,
  Resource: Resource,
  Link: Link,
  FullScreenCode: FullScreenCode,
  QuoteLayout: QuoteLayout,
  React: React
};